/* eslint-disable no-nested-ternary */
import React from "react";
import { object } from "prop-types";
import { Tabs, Tab } from "../../TabsAndAccordions/Tabs";
import { ParagraphSectionConnector } from "../../ParagraphSection";
import { RCL } from "../../RCL";

const DescriptionTabs = ({ overviewTab, weddingsTab, groupsTab, travelTipsDescription }) => (
	<Tabs variant="stone">
		{overviewTab && (
			<Tab eventKey="overview" title={RCL({ searchKey: "overview" })}>
				<ParagraphSectionConnector data={overviewTab} />
			</Tab>
		)}
		{travelTipsDescription && (
			<Tab eventKey="travelTips" title={RCL({ searchKey: "travel-tips" })}>
				<ParagraphSectionConnector data={travelTipsDescription} />
			</Tab>
		)}
		{weddingsTab && (
			<Tab
				eventKey="weddings"
				title={RCL({ searchKey: "weddings" })}
				newLabel={RCL({ searchKey: "new" })}>
				<ParagraphSectionConnector data={weddingsTab} />
			</Tab>
		)}
		{groupsTab && (
			<Tab eventKey="groups" title={RCL({ searchKey: "groups" })}>
				<ParagraphSectionConnector data={groupsTab} />
			</Tab>
		)}
	</Tabs>
);

DescriptionTabs.propTypes = {
	overviewTab: object,
	weddingsTab: object,
	groupsTab: object,
	travelTipsDescription: object,
};

DescriptionTabs.defaultProps = {
	overviewTab: null,
	weddingsTab: null,
	groupsTab: null,
	travelTipsDescription: null,
};

export default DescriptionTabs;
export { DescriptionTabs };
